import React from "react";
import {
    Box,
    Button,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Typography,
} from "@mui/material";
import {
    catalogDangerButtonSx,
    catalogQuietButtonSx,
} from "../Products/catalogGridStyles.js";

/**
 * Shared confirm step before destructive deletes (toolbar / row actions).
 */
export default function ConfirmDeleteDialog({
    open,
    onClose,
    onConfirm,
    title,
    description = "This cannot be undone.",
    items = [],
    confirming = false,
    confirmLabel = "Delete",
}) {
    return (
        <Dialog open={open} onClose={confirming ? undefined : onClose} maxWidth="sm" fullWidth>
            <DialogTitle sx={{ fontWeight: 700 }}>{title}</DialogTitle>
            <DialogContent>
                {description ? (
                    <Typography sx={{ fontSize: 14, color: "#5c6570", mb: items.length ? 1.5 : 0 }}>
                        {description}
                    </Typography>
                ) : null}
                {items.length > 0 ? (
                    <Box component="ul" sx={{ m: 0, pl: 2.5, maxHeight: 220, overflowY: "auto" }}>
                        {items.map((item) => {
                            const key = typeof item === "string" ? item : item.key;
                            const label = typeof item === "string" ? item : item.label;
                            return (
                                <Typography
                                    component="li"
                                    key={key}
                                    sx={{ fontSize: 14, fontWeight: 600 }}
                                >
                                    {label}
                                </Typography>
                            );
                        })}
                    </Box>
                ) : null}
            </DialogContent>
            <DialogActions sx={{ px: 3, pb: 2 }}>
                <Button onClick={onClose} disabled={confirming} sx={catalogQuietButtonSx}>
                    Cancel
                </Button>
                <Button
                    onClick={onConfirm}
                    disabled={confirming}
                    sx={catalogDangerButtonSx}
                    startIcon={
                        confirming ? <CircularProgress size={14} color="error" /> : null
                    }
                >
                    {confirmLabel}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
